var _excluded = ["wrapClassName", "width", "closeIcon", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { memo } from 'react';
import { CloseOutlined } from '@aelf-design/icons';
import { Modal as AntdModal } from 'antd';
import { useTheme } from 'antd-style';
import useStyles from "./style";
function Modal(_ref) {
  var wrapClassName = _ref.wrapClassName,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 438 : _ref$width,
    _ref$closeIcon = _ref.closeIcon,
    closeIcon = _ref$closeIcon === void 0 ? true : _ref$closeIcon,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx;
  var token = useTheme();
  return /*#__PURE__*/React.createElement(AntdModal, _extends({}, props, {
    width: width,
    wrapClassName: cx(styles.modalWrap, wrapClassName),
    closeIcon: closeIcon ? /*#__PURE__*/React.createElement("div", {
      className: styles.closeIconWrap
    }, /*#__PURE__*/React.createElement(CloseOutlined, {
      color: token === null || token === void 0 ? void 0 : token.colorTextBase
    })) : null
  }), children);
}
export default /*#__PURE__*/memo(Modal);